import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { OcPageTransition } from "oc/components";

export const MyHRUserNotFoundPage = () => {
  const history = useHistory();
  const theme = useTheme();

  const handleBack = () => {
    history.push("/");
  };

  return (
    <OcPageTransition>
      <Box
        id="not-found-page"
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h1" color={theme.palette.primary.main}>
          404
        </Typography>
        <Box paddingTop="32px">
          <Typography variant="h4">
            Sajnáljuk, de nem találjuk a keresett oldalt
          </Typography>
        </Box>
        <Box
          marginTop="32px"
          onClick={handleBack}
          style={{ cursor: "pointer" }}
        >
          <Typography variant="body1" color={theme.palette.primary.main}>
            Vissza a főoldalra
          </Typography>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyHRUserNotFoundPage;
